var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseListV2',{attrs:{"model-class":_vm.DataLabel,"collection-filter":_vm.filter,"hasDetailView":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }